<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="" title="Suppliers" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<div class="col-md-12 project-list page-subtitle">
								<div class="row">
									<div class="col-md-12">
										<button class="btn btn-primary float-end" type="button" data-original-title="test" @click="openModal">Add Supplier</button>
									</div>
								</div>
							</div>

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-8 d-flex mt-2">
										<label class="d-flex listing-length ms-1"><span>Show</span>
											<!-- <select class="form-control" v-model="listing_length" @change="fetchUsers()"> -->
											<select class="form-select" v-model="listing_length" @change="fetchSuppliers()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									
									<div class="col-md-2 mt-2">
										<select class="form-select" v-model="status" @change="fetchSuppliers()">
											<option value="">All</option>
                                            <option value="1">Active</option>
                                            <option value="2">Blocked</option>
										</select>
									</div>
									<div class="col-md-2 mt-2">
										<input type="text" class="form-control ms-1" placeholder="Search" v-model="keyword" @keyup="fetchSuppliers()"/>
									</div>
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
                                            <th>ID</th>  
                                            <th>Name</th>
											<th>Mobile</th>
											<th>Address</th>
											<th>City</th>
											<th>State</th>
											<th>Options</th>
                                        </tr>
									</thead>
									<tbody v-if="Boolean(suppliers.length)">
                                        <tr align="center" v-for="supplier in suppliers" :key="supplier.id">
                                            <td>#{{supplier.id}}</td>
                                            <td>{{supplier.name}}</td>
											<td>{{supplier.mobile}}</td>
											<td>{{supplier.address}}</td>
											<td>{{supplier.city}}</td>
											<td>{{supplier.state}}</td>
											<td>
												<button class="btn btn-primary btn-sm me-1 mb-2" @click="editSupplier(supplier)">Edit</button>
											</td>
                                        </tr>

									</tbody>
									<tbody v-else>
										<tr>
											<td colspan="7" align="center">No data available</td>
										</tr>

									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<caption v-if="Boolean(suppliers.length)" class="float-start mt-2 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>
							<nav aria-label="Page navigation" class="mt-2 float-end">
								<ul class="pagination">
									<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
										<a class="page-link" href="#" @click.prevent="fetchSuppliers(page.url + '&limit=' + listing_length + '&status=' + status + '&keyword=' + keyword)" tabindex="-1">
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav>
							<!----pagination ends --->
							
						</div>
					</div>
				</div>
			</div>
		</div>

		<DynamicModal :title="modal_title">
			<template #body>
				<form @submit.prevent="addSupplier" enctype="multipart/form-data">

					<div class="row mt-2">
						<div class="col-md-12 form-group">
							<label class="control-label">Supplier Name<span class="text-danger">*</span></label>
							<input class="form-control" v-model="supplier.name" type="text" placeholder="" />
						</div>
					</div>

					<div class="row mt-2">
						<div class="col-md-12 form-group">
							<label class="control-label">Mobile<span class="text-danger">*</span></label>
							<input class="form-control" v-model="supplier.mobile" v-mobile-limit placeholder="" maxlength="10" minlength="10" />
						</div>	
					</div>

					<div class="row mt-2">
						<div class="col-md-12 form-group">
							<label class="control-label">Address<span class="text-danger">*</span></label>
							<input class="form-control" v-model="supplier.address" type="text" placeholder="" />
						</div>	
					</div>

					<div class="row mt-2">
						<div class="col-md-12 form-group">
							<label class="control-label">City<span class="text-danger">*</span></label>
							<input class="form-control" v-model="supplier.city" type="text" placeholder="" />
						</div>
					</div>

					<div class="row mt-2">
						<div class="col-md-12 form-group">
							<label class="control-label">State<span class="text-danger">*</span></label>
							<input class="form-control" v-model="supplier.state" type="text" placeholder="" />
						</div>
					</div>

					<div class="col-md-12 form-group mt-3">
						<button type="submit" class="btn btn-primary me-3" :disabled="submitting">
							<span v-if="submitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
							{{ submitting ? "Saving..." : button_title }}
						</button>
						<button type="button" class="btn btn-light" @click="closeModal()" :disabled="submitting">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>

	</div>
</template>

<script>
import {
    Tooltip
} from 'bootstrap/dist/js/bootstrap.esm.min.js'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'

	export default {
		name: "User Page",
		components: {
			DynamicModal
		},

		data() {
			return {
				dynamicmodal: null,
				
				modal_title: "Add Supplier",
				button_title: "Save",
				
				keyword: "",
				showsearch: false,
				listing_length: 10,
				token: "",
				status:"",
				submitting: false,
				errors: {},

				suppliers:[],

				supplier:{
					id:"",
					name:"",
					mobile:"",
					address:"",
					city:"",
					state:"",
				},
				edit: false,

                button_title: "Save",
			
			};
		},

		mounted() {
			this.dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
            new Tooltip(document.body, {
                    selector: "[data-bs-toggle='tooltip']",
                })
        },
        unmounted() {

            let popovers = document.getElementsByClassName('tooltip')
            // popovers.forEach(item => {
            //     item.remove()
            // })

        },

		created() {

			this.fetchSuppliers();

		},
		methods: {

			getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {

						this.token = airotrack_staff.token;
						this.user = airotrack_staff;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},
			
			fetchSuppliers(page_url = null) {
				this.getToken();
				let url = "/staffs/getSuppliers?limit=" + this.listing_length  + "&status=" + this.status + "&keyword=" + this.keyword;
				page_url = page_url || url;
				this.active_page_url = page_url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						this.suppliers = responseData.suppliers.data || [];
						this.pagination = responseData.suppliers.links || [];
						this.from = responseData.suppliers.from || 0;
						this.to = responseData.suppliers.to || 0;
						this.total = responseData.suppliers.total || 0;
						
					})
					.catch((err) => console.log(err));
			},
			
			openModal() {
				this.clearForm();
				this.dynamicmodal?.show();
			},

			closeModal() {
				this.dynamicmodal?.hide();
			},

			editSupplier(supplier) {
				this.edit = true;
				this.errors = {};
				this.modal_title = "Edit Supplier";
				this.button_title = "Update";
				this.supplier = {
					id: supplier.id,
					name: supplier.name,
					mobile: supplier.mobile,
					address: supplier.address,
					city: supplier.city,
					state: supplier.state,
				};
				this.dynamicmodal?.show();
			},

			addSupplier() 
			{
				if (this.submitting) return;
				this.submitting = true;
				this.getToken();
				let formData = new FormData();
                formData.append("name", this.supplier.name);
                formData.append("mobile", this.supplier.mobile);
                formData.append("address", this.supplier.address);
                formData.append("city", this.supplier.city);
                formData.append("state", this.supplier.state);
				const config = {
					headers: {
						"content-type": "multipart/form-data",
						Authorization: "Bearer " + this.token,
					},
				};
				let url;
				if (!this.edit) {
					url = "/staffs/createSupplier";
					this.active_page_url = null;
				} else {
					url = "/staffs/updateSupplier";
					formData.append("supplier_id", this.supplier.id);
				}
				this.$axios
					.post(url, formData, config)
					.then((response) => {
						if (response.data.status) {
							this.$swal("", response.data.message, "success");
						} else {
							this.$swal("", response.data.message, "error");
						}
						this.clearForm();
						this.closeModal();
						this.fetchSuppliers(this.active_page_url);
					})
					.catch((error) => {
						if (error.response) {
							if (error.response.data.message) {
								this.errors = error.response.data.message;
								this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					})
					.finally(() => {
						this.submitting = false;
					});
			},

			clearForm() {
				this.edit = false;
				this.modal_title = "Add Supplier";
				this.button_title = "Save";
				this.supplier.id = "";
                this.supplier.name = "";
				this.supplier.mobile = "";
				this.supplier.address = "";
				this.supplier.city = "";
				this.supplier.state = "";
				this.errors = {};
			},

		},
	};
</script>